import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DOT_STYLES = {
  green: 'bg-emerald-500',
  yellow: 'bg-amber-500 animate-pulse',
  red: 'bg-red-500 animate-pulse',
  off: 'bg-slate-400',
};

export const HubStatusDot = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const load = () =>
      axios
        .get(`${BACKEND_URL}/api/super-admin/hub-status`, { withCredentials: true })
        .then(({ data }) => setStatus(data))
        .catch(() => setStatus(null));

    load();
    const timer = setInterval(load, 60000);
    return () => clearInterval(timer);
  }, []);

  if (!status) return null;

  const dotClass = DOT_STYLES[status.status] || DOT_STYLES.off;
  const tooltip = [
    `${status.label} — ${status.detail}`,
    `Sucessos 24h: ${status.success_24h ?? 0} · Falhas 24h: ${status.failure_24h ?? 0}`,
    status.last_success ? `Última entrega OK: ${new Date(status.last_success).toLocaleString('pt-PT')}` : null,
    status.last_failure ? `Última falha: ${new Date(status.last_failure).toLocaleString('pt-PT')}` : null,
  ].filter(Boolean).join('\n');

  return (
    <button
      onClick={() => navigate('/superadmin/platform')}
      title={tooltip}
      data-testid="hub-status-dot"
      data-testid-status={status.status}
      className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-slate-200 dark:border-slate-700 hover:border-slate-400 transition-colors"
    >
      <span className={`w-2 h-2 rounded-full ${dotClass}`} />
      <span className="text-xs text-slate-600 dark:text-slate-300 hidden sm:inline">{status.label}</span>
    </button>
  );
};

export default HubStatusDot;
